import * as React from "react"
import { saInterfacesApprenticeStepsContainer } from "../saTypes"

// @ts-ignore
import { saApprenticeStepsContainer, saApprenticeSteps, saStepItem, saNum,saTitle, saText,saSectionTitleContainer,saSectionTitle,saSectionSubtitleContainer,saSectionSubtitle } from "./saSteps.module.scss"
import { SaTitle } from "../saTitle/saTitle"
import { SaSubtitle } from "../saTitle/saSubtitle"





export const SaSteps: React.FC<saInterfacesApprenticeStepsContainer> = ({ ...props }) =>  {


  let list = Object.values(props.steps)

  let listItems = list.map((item, index)  => (
      <div key={index} className={saStepItem}>
        <div className={saNum}>
          {index + 1}
        </div>
        <div>
        {
          item.title &&
          <div className={saTitle}>
            {item.title}
          </div>
        }
        {
          item.text &&
          <div className={saText}>
            {item.text}
          </div>
        }
        </div>
      </div>
    )
  )


  return (
    <div className={saApprenticeStepsContainer}>


      <div className={'saContainer'}>
        {
          props.sectionTitle &&
          <div className={saSectionTitleContainer}>
            <SaTitle title={props.sectionTitle} classes={saSectionTitle}/>
          </div>
        }

        {
          props.subtitle &&
          <div className={saSectionSubtitleContainer}>
            <SaSubtitle title={props.subtitle} classes={saSectionSubtitle}/>
          </div>
        }
      </div>

      <div className={'saContainer ' + saApprenticeSteps}>
        { listItems }
      </div>
    </div>
  )
}
